import React from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';

function NotFound() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <div>
        <Search
          size={56}
          style={{ color: 'var(--text-muted)', marginBottom: '20px' }}
        />
        <h1
          style={{
            fontSize: '28px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            marginBottom: '12px',
          }}
        >
          Page Not Found
        </h1>
        <p
          style={{
            fontSize: '15px',
            color: 'var(--text-secondary)',
            marginBottom: '28px',
            maxWidth: '400px',
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
